import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .outer-container {
    min-height: 100vh;
  }

  .outer-container.default,
  .inner-container.default {
    background: ${colors.baseBg};
  }

  .outer-container.home {
    background: ${colors.baseBg};
  }

  .inner-container.default,
  .inner-container.home {
    position: relative;
    margin: 0 auto;
    z-index: 1;
  }

  .inner-container.default {
    max-width: 1920px;
  }

  .inner-container.default :global(main) {
    max-width: 1024px;  
    margin: 0 auto;
  }

  .inner-container.home {
    background-color: ${colors.baseBg};
    max-width: 1920px;
  }

  .content {
    display: flex;
  }

  .bumper:not(.home):not(.navlessLandingPage) {
    height: 73px;
  }

  .home .content {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.1);
  }

  .main-content {
    position: relative;
    min-width: 100%;
  }

  @media (min-width: 1024px) {
    .inner-container.default :global(.PageFooter > div) {
      padding: 2rem;
    }
  }

  .inner-container.default :global(hr) {
    max-width: 960px;
  }

  .page-body {
    top: 70%;
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  @media (max-width:1199px){
    .page-body {
    top: auto;
    position: absolute;
    width: 100%;
    }
        
    .inner-container.default :global(main) {
      margin: 0 24px;
    }
  }

  @media (max-width: 767px) {
    .inner-container.default :global(main) {
      margin: 0 8px;
    }
  }

  // @media (max-width:495px){
  //   .inner-container.home { padding-top: 3em };
  // }

`
